const translations = {
  "en": {
    "Core Team": "Core Team",
    "Investors": "Investors",
    "Key Stats": "Key Stats",
    "Social Hype": "Social Hype",
    "What is BTC?": "What is BTC?"
  },
  "zh-tw": {
    "Core Team": "核心團隊",
    "Investors": "投資者",
    "Key Stats": "關鍵數據",
    "Social Hype": "社交熱潮",
    "What is BTC?": "什麼是 BTC？"
  }
};

export default translations;
